/* eslint-disable max-len */
import { Button, Icon, theme } from '@dasa-health/components-react'
import React, { useState } from 'react'
import { SignUpModal } from 'redesign/components/molecules/SignUpModal'
import { MiscOutlineQuestioncircle } from '@dasa-health/icons'
import { ModalDataContainer } from '../style'

export const LegalNameModalButton = () => {
    const [isOpen, setIsOpen] = useState(false)
    return (
        <>
            <div>
                <Button borderRadius="pill" onClick={() => setIsOpen(true)} size="compact" type="button" variant="tertiary">
                    <Icon color={theme.colors.black} size={26}>
                        <MiscOutlineQuestioncircle />
                    </Icon>
                </Button>
            </div>
            {isOpen && (
                <ModalDataContainer>
                    <SignUpModal
                        setShowModal={() => {
                            setIsOpen(v => !v)
                        }}
                        showModal={isOpen}
                        title="O que é nome legal?"
                    >
                        <p>
                            É o <strong>nome de registro</strong> na Receita Federal e que está presente em sua Certidão de Nascimento.{' '}
                            <strong>Pessoas transgênero</strong> podem ter em sua documentação o <strong>nome social</strong> e devem
                            ser chamadas por ele, conforme a lei.
                        </p>
                    </SignUpModal>
                </ModalDataContainer>
            )}
        </>
    )
}
